import { gql } from '@apollo/client';

const PATIENT_RETURN_FRAGMENT = gql`
  fragment PatientReturnFragment on PatientReturn {
    id
    markDeviceReturned
    studyEndDate
    receivedItems {
      name
      checkBox
    }
    notes
    actionDisableMarkReturned
    returnDate
    returnLabels {
      id
      transaction {
        id
        status
        trackingNumber
        trackingStatus
        labelUrl
        trackingUrlProvider
        eta
      }
      rate {
        id
        carrier
        carrierLogo200
        amount
        estimatedDays
        attributes
        serviceLevelName
      }
      shipmentDate
      tracking {
        trackingHistory {
          status
          statusDetails
          statusDate
          location {
            name
            street1
            city
            country
            state
            zip
            phone
            email
          }
        }
      }
    }
    lastReturnLabel {
      tracking {
        trackingHistory {
          status
          statusDate
        }
      }
    }
  }
`;

export default PATIENT_RETURN_FRAGMENT;
